import { useState } from 'react'
import { apiService } from '../services/api'
import { FinancialCharge, FinancialChargeFormData } from '../types'

export const useFinancialCharges = () => {
 const [charges, setCharges] = useState<FinancialCharge[]>([])
 const [isLoading, setIsLoading] = useState(true)
 const [error, setError] = useState<string | null>(null)
 const [pagination, setPagination] = useState({
 page: 1,
 limit: 50,
 total: 0,
 totalPages: 0
 })

 const fetchCharges = async (params?: {
 page?: number
 limit?: number
 vehicleId?: string
 type?: string
 category?: string
 search?: string
 }) => {
 try {
 setIsLoading(true)
 setError(null)
 const response = await apiService.getFinancialCharges(params)
 
 if (response && typeof response === 'object' && 'charges' in response) {
 setCharges(response.charges || [])
 if (response.pagination) {
 setPagination(response.pagination)
 }
 } else if (Array.isArray(response)) {
 setCharges(response)
 } else {
 setCharges([])
 }
 } catch (err) {
 console.error('Erro ao carregar encargos:', err)
 setError('Erro ao carregar encargos. Tente novamente.')
 setCharges([])
 } finally {
 setIsLoading(false)
 }
 }

 const createCharge = async (chargeData: FinancialChargeFormData) => {
 try {
 const newCharge = await apiService.createFinancialCharge(chargeData)
 if (newCharge) {
 setCharges(prev => [newCharge, ...prev])
 return newCharge
 }
 throw new Error('Encargo criado mas sem dados retornados')
 } catch (err) {
 console.error('Erro ao criar encargo:', err)
 setError('Erro ao criar encargo. Tente novamente.')
 throw err
 }
 }

 const updateCharge = async (id: string, chargeData: Partial<FinancialChargeFormData>) => {
 try {
 const updatedCharge = await apiService.updateFinancialCharge(id, chargeData)
 if (updatedCharge) {
 setCharges(prev => prev.map(charge => charge.id === id ? updatedCharge : charge))
 return updatedCharge
 }
 throw new Error('Encargo atualizado mas sem dados retornados')
 } catch (err) {
 console.error('Erro ao atualizar encargo:', err)
 setError('Erro ao atualizar encargo. Tente novamente.')
 throw err
 }
 }

 const deleteCharge = async (id: string) => {
 try {
 await apiService.deleteFinancialCharge(id)
 setCharges(prev => prev.filter(charge => charge.id !== id))
 } catch (err) {
 console.error('Erro ao deletar encargo:', err)
 setError('Erro ao deletar encargo. Tente novamente.')
 throw err
 }
 }

 // Removido useEffect automático - carregamento deve ser manual quando necessário

 return {
 charges,
 isLoading,
 error,
 pagination,
 fetchCharges,
 createCharge,
 updateCharge,
 deleteCharge
 }
}
